<template>
  <s-wrapper>
    <label v-if="label">
      {{ label }}
    </label>

    <select
      name="select"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
    >
      <option
        v-for="(option, index) in options"
        :key="option.value + index"
        :value="option.value"
        :disabled="option.value == null"
        :selected="option.value == null"
      >
        {{ option.label }}
      </option>
    </select>
  </s-wrapper>
</template>

<script>
import { SWrapper } from "./styles";

export default {
  name: "FormSelect",
  components: {
    SWrapper
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
